import React, {useState} from "react";

export default function PhotoBlock({ item }) {

    // Load the logo
    const [mediaFile, setMediaFile] = useState(null);
    React.useEffect(() => {
        if (item.data['media']) {
            setMediaFile(item.data['media'].preview_url);
        }
    }, [item])

    return (
        <div className="">
            {item &&
                <>
                    { mediaFile &&
                        <img src={mediaFile}/>
                    }
                </>
            }
        </div>
    );
}